module.exports = __webpack_public_path__ + "static/01-2b87aa91df0d21a9e8b2c2a319c66a1f.jpg";